/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

.container {
  margin: 0 auto;
  max-width: 1200px;
  padding: 24px;
}

.header {
  margin-bottom: 32px;
}

.headerGrid {
  align-items: center;
  display: flex;
  gap: 12px;
}

.avatar {
  height: 80px;
  width: 80px;
  background-color: #5b1dc2;
}

.orgName {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.orgName.bold,
.orgName .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .orgName {
    font-size: 24px;
    line-height: 150%;
  }
}
.orgName {
  font-weight: 600;
}

.section {
  margin-bottom: 16px;
}

.sectionHeader {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
  border-radius: 8px;
  padding: 8px 16px;
  width: 100%;
  margin-bottom: 16px;
}
.sectionHeader.shaded {
  background: linear-gradient(92deg, #ffead7 0%, #e9e1f8 100%);
  margin: 24px 0;
}

.overviewTable {
  border: unset;
  border-collapse: collapse;
  width: 100%;
}
.overviewTable td {
  padding: 8px 0;
}
.overviewTable td:first-child {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.overviewTable td:first-child.bold,
.overviewTable td:first-child .bold {
  font-weight: 600;
}
.overviewTable td:first-child {
  font-weight: 600;
  width: 240px;
}
.overviewTable th,
.overviewTable td {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.overviewTable th.bold,
.overviewTable th .bold,
.overviewTable td.bold,
.overviewTable td .bold {
  font-weight: 600;
}
.overviewTable th,
.overviewTable td {
  color: #000;
  padding: 8px 16px;
}
.overviewTable tr {
  border-bottom: 1px solid #f5f5f5;
}
.overviewTable tr:last-child {
  border-bottom: unset;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */